<template>
    <div class="card">
        <h4 class="card-header">
            <PublicationLabel :publication="{name: $t('publications.about')}" />
        </h4>

        <ul class="list-group list-group-flush">
            <li class="list-group-item">
                <TagsLabel class="d-block" :tags="publication.tags" />
                <TagsLabel v-if="$gate.allow('browse', 'action')" :tags="publication.tags" is-configuration />
                <WorkflowLabel class="d-block" show-link :workflow="publication.workflow" />
            </li>

            <li v-if="publication.notes" class="list-group-item">
                <NotesLabel :notes="publication.notes" />
            </li>

            <li class="list-group-item">
                <EditionLabel :publication="publication" :edition="edition" show-link />
            </li>

            <li v-if="$gate.user.isStaff && edition && edition.filesystem" class="list-group-item">
                <FilesystemLabel :filesystem="edition.filesystem" />
            </li>

            <li class="list-group-item">
                <LanguageLabel class="d-block" :languages="publication.languages" />
                <span v-if="publication.frequency" class="d-block">
                    {{ publication.frequency }}
                </span>
            </li>

            <li v-if="publication.primary_contact" class="list-group-item">
                <ContactLabel show-link :user="publication.primary_contact" />
                <EmailLabel class="d-block" :email="publication.primary_contact.email" />
                <PhoneLabel class="d-block" :phone="publication.primary_contact.phone" />
            </li>

            <li v-if="publication.secondary_contact" class="list-group-item">
                <ContactLabel show-link is-secondary :user="publication.secondary_contact" />
                <EmailLabel class="d-block" :email="publication.secondary_contact.email" />
                <PhoneLabel class="d-block" :phone="publication.secondary_contact.phone" />
            </li>

            <li class="list-group-item">
                <PublicationLabel show-name show-link :publication="publication" />
                <div
                    v-if="publication.address_1"
                    class="small text-prewrap text-muted mt-2"
                    v-html="publication.address_1" />
                <div
                    v-if="publication.address_2"
                    class="small text-prewrap text-muted mt-2"
                    v-html="publication.address_2" />
            </li>
        </ul>
    </div>
</template>

<script>
import ContactLabel from '@/js/components/common/labels/ContactLabel';
import EditionLabel from '@/js/components/edition/EditionLabel';
import EmailLabel from '@/js/components/common/labels/EmailLabel';
import FilesystemLabel from '@/js/components/common/labels/FilesystemLabel';
import LanguageLabel from '@/js/components/common/labels/LanguageLabel';
import PhoneLabel from '@/js/components/common/labels/PhoneLabel';
import PublicationLabel from '@/js/components/publication/PublicationLabel';
import TagsLabel from '@/js/components/common/labels/TagsLabel';
import WorkflowLabel from '@/js/components/workflow/WorkflowLabel';
import NotesLabel from '@/js/components/common/labels/NotesLabel';

export default {
    name: 'PublicationEditionCard',

    components: {
        NotesLabel,
        ContactLabel,
        EditionLabel,
        EmailLabel,
        FilesystemLabel,
        LanguageLabel,
        PublicationLabel,
        PhoneLabel,
        TagsLabel,
        WorkflowLabel,
    },

    props: {
        publication: {type: Object, required: true},
        edition: {type: Object, required: true},
    },
};
</script>
